import { canv } from '@/canv/global.js'

export class shapeDownTriangle {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var k = height * width / (height + width);

        var allowedWidth = k;
        var allowedHeight = k - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + k/2 + textPart.lines[0].textHeight - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y);
        canv.ctx.lineTo(x + width, y);
        canv.ctx.lineTo(x + width / 2, y + height);
        canv.ctx.lineTo(x, y);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="60" height="70" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 35L60 0.358978V69.641L0 35Z" fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.4593 0.75L11.5 18L1.54071 0.75L21.4593 0.75Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
